module.exports = __webpack_public_path__ + "img/icon-sms.3d51aabf.svg";